import get from 'lodash/get'
import * as Redux from 'redux'
import * as ReduxObservable from 'redux-observable'
import * as App from '../../../app'
import * as Form from '../../../components/form'
import * as Menu from '../../../components/menu'
import * as Elasticsearch from '../../../elasticsearch'
import * as Request from '../../../request'
import {ApplicationState} from '../../../rootReducer'
import * as Router from '../../../router'
import * as CommunityConfig from '../../community-config'
import * as ReportUtils from '../utils'
import * as Actions from './actions'
import * as Constants from './constants'
import * as Reducer from './reducer'
import * as Utils from './utils'

const {DateHistogram} = Constants.AggregationNames

type OnEnter = ReduxObservable.Epic<Redux.Action, ApplicationState>
const onEnter: OnEnter = (action$, store, {history}) =>
  action$.ofType(Router.ON_ENTER, Constants.FormConstants.UPDATE)
    .filter(() => history.location.pathname.startsWith(Menu.REPORTS_ANALYTICS_URL) ||
                  history.location.pathname.startsWith(Menu.REPORTS_ENGAGEMENT_URL))
    .filter((action) => get(action, 'value.name') !== Constants.FieldNames.totalsVsUniques)
    .map(store.getState)
    .filter((state) => ReportUtils.validDateRange(state.analytics.form))
    .map(({app, analytics}) => ({
      analytics: {
        ...analytics,
        form: {
          ...analytics.form,
          fields: {
            ...analytics.form.fields,
            ...App.filterObject(app.urlParams, analytics.form.fields),
          }}},
      app,
    }))
    .map(({app, analytics: {form}}) =>
        Actions.esSearch(
        form.fields.community || app.selectedCommunity,
        Elasticsearch.Indexes.EmailActions,
        Elasticsearch.buildAggBody()
          .filter(
            'term',
            Elasticsearch.keyword(Elasticsearch.DocumentFieldNames.MessageType),
            Elasticsearch.NEWSBRIEF_MESSAGE)
          .filter(
            'term',
            Elasticsearch.DocumentFieldNames.IncludeInReports,
            true)
          .filter(
            'term',
            Elasticsearch.keyword(Elasticsearch.DocumentFieldNames.Community),
            (form.fields.community || app.selectedCommunity))
          .query(
            'range',
            Elasticsearch.DocumentFieldNames.MessageSendDate,
            ReportUtils.searchDateRange(form),
          ).aggregation(
            'terms',
            Elasticsearch.keyword(Elasticsearch.DocumentFieldNames.EventName),
            Elasticsearch.DocumentFieldNames.EventName,
            (a: any) => a.aggregation(
              DateHistogram,
              Elasticsearch.DocumentFieldNames.MessageSendDate,
              { interval: form.fields.groupBy },
              Elasticsearch.AggFieldNames.TotalCount,
              (subAgg: any) => subAgg.aggregation(
                'cardinality',
                Elasticsearch.DocumentFieldNames.CommunityPersonId,
                {
                  precision_threshold: 40000,
                },
                Elasticsearch.AggFieldNames.UniqueCount,
              ),
            ),
          ).build(),
      ),
    )

const formEnter: ReduxObservable.Epic<Redux.Action, ApplicationState> = (action$, store, {history}) =>
  action$.ofType(Router.ON_ENTER)
    .filter(() => history.location.pathname.startsWith(Menu.REPORTS_ANALYTICS_URL) ||
                  history.location.pathname.startsWith(Menu.REPORTS_ENGAGEMENT_URL))
    .map(store.getState)
    .map(({analytics, app}) => Actions.FormActions[Form.ENTER]({
      ...Reducer.initialFieldValues,
      ...analytics.form.fields,
      ...App.filterObject(app.urlParams, Reducer.initialFieldValues),
    }))

const defaultView: ReduxObservable.Epic<Redux.Action, any> = (action$, store, {history}) => action$
  .ofType(Request.successConstant(CommunityConfig.FETCH_COMMUNITY_CONFIG))
  .filter(() => history.location.pathname.startsWith(Menu.REPORTS_ANALYTICS_URL) ||
                history.location.pathname.startsWith(Menu.REPORTS_ENGAGEMENT_URL))
  .map(Utils.selectEngagmentDefault)
  .filter(Boolean)
  .map((value) => Actions.FormActions[Form.UPDATE]({
    name: Constants.FieldNames.totalsVsUniques,
    value,
  }))

export const epic = ReduxObservable.combineEpics(onEnter, defaultView, formEnter)



// WEBPACK FOOTER //
// ./src/pages/reports/analytics/epic.ts